export function getSubdomain(url: string): string | null {
  try {
    const { hostname } = new URL(url)

    // check for hostname being ip addresses
    const ipv4Regex = /^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/
    if (ipv4Regex.test(hostname) || hostname.includes(':')) {
      return null
    }

    const parts = hostname.split('.')

    // A hostname with at least 3 parts means it has a subdomain
    if (parts.length > 2) {
      return parts[0]
    } else {
      return null
    }
    // eslint-disable-next-line @glovo/custom-rules/always-forward-error
  } catch (_e) {
    return null
  }
}
